import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import UnForm from "../../../../../Components/Form";
import { Spinner } from "../../../../../Components/Loding/SpinnerPadrao";
import {
    AtualizarReguaController,
    GetReguaController,
} from "../../../../../Controllers/Automacao/Regua/GestaoDeRegua/GestaoDeReguaControllers";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";

interface IEditarNomeReguaProps {
    idRegua: number;
}
interface IEditarNomeReguaFormData {
    DS_NOME_REGUA: string;
}

export function EditarNomeRegua(props: IEditarNomeReguaProps) {
    const [editando, setEditando] = useState(false);

    const { value: Regua, execute: updateRegua } = useAsyncEffect(() => {
        return GetReguaController(props.idRegua);
    }, [props.idRegua]);

    const { execute: handleEditReguaNameFormSubmit, loading } =
        useAsyncCallback(async (formData: IEditarNomeReguaFormData) => {
            if (
                formData.DS_NOME_REGUA &&
                formData.DS_NOME_REGUA !== Regua?.DS_NOME_REGUA
            ) {
                await AtualizarReguaController({
                    DS_NOME_REGUA: formData.DS_NOME_REGUA,
                    ID_CASO_COBRANCA_REGUA: props.idRegua,
                });
                await updateRegua().then(() => setEditando(false));
            } else setEditando(false);
        });

    return editando ? (
        <UnForm
            handleSubmit={handleEditReguaNameFormSubmit}
            className="d-flex w-100 my-4"
        >
            <UnForm.Input
                name="DS_NOME_REGUA"
                className="w-100"
                wrapperClassName="w-100"
                disabled={loading}
                defaultValue={Regua?.DS_NOME_REGUA}
            />
            <button
                className="btn btn-outline-primary"
                type="submit"
                disabled={loading}
            >
                {loading ? (
                    <Spinner size="sm" />
                ) : (
                    <FontAwesomeIcon icon={faEdit} />
                )}
            </button>
        </UnForm>
    ) : (
        <span className="d-flex align-items-center justify-content-start g-2 w-100 my-4">
            {Regua?.DS_NOME_REGUA}
            <button
                className="btn btn-outline-primary"
                onClick={() => setEditando(true)}
            >
                <FontAwesomeIcon icon={faEdit} />
            </button>
        </span>
    );
}
